import { apiMethods } from "data/api.constants";
import { SEND_REMAINDER } from "features/AffiliateMarketing/constants/Affliates.api";
import { dataProvider } from "data";

export const sendRemainder = (payload) => {
  return dataProvider.custom_request(SEND_REMAINDER, apiMethods.POST, payload);
};
